import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import countries from './master-data-management/countries.js';

/**
 * @entity ZipCity
 */
@Entity()
export class ZipCity extends AdornisEntity {
  public static override _class = 'ZipCity';

  @Field(() => String)
  public zip: Maybe<string>;

  @Field(() => String)
  public city: Maybe<string>;

  override toString() {
    return `${this.zip ?? ''}${this.zip && this.city ? ' ' : ''}${this.city ?? ''}`;
  }
}

/**
 * @entity Adresse
 */
@Entity()
export class Adresse extends AdornisEntity {
  public static override _class = 'Adresse';

  @Field(() => String)
  public strasse: Maybe<string>;

  @Field(() => String)
  public careOf: Maybe<string>;

  @Field(() => String)
  public country: Maybe<string>;

  @Field(() => ZipCity, {
    default: v => v ?? new ZipCity({}),
  })
  public zipCity: Maybe<ZipCity>;

  public static override resolveID(): string {
    return A.getGloballyUniqueID();
  }

  override toString() {
    return [
      this.zipCity?.zip,
      this.zipCity?.city,
      this.strasse ? `, ${this.strasse}` : null,
      this.country ? `, ${countries[this.country]}` : null,
    ]
      .filter(Boolean)
      .join(' ')
      .replaceAll(' ,', ',')
      .replaceAll(' , ', ', ');
  }
}
